import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './PasswordCriteriaCheck.html?raw';
import '../Edit/Edit';
import { TranslationHelpers } from "../../../more/Helpers";

//import DataItems = require("DataItems");


class PasswordCriteriaCheck extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private messageContainer: HTMLElement;

    private passwordChange_display_letter: HTMLElement;
    private passwordChange_display_capital: HTMLElement;
    private passwordChange_display_number: HTMLElement;
    private passwordChange_display_length: HTMLElement;
    private minimumPasswordLengthDisplay: HTMLElement;
    private passwordChange_display_specialCharacters: HTMLElement;
    //private passwordChange_display_confirm: HTMLElement;
    //private passwdConfirmationDisplay: HTMLElement;
    private txtCriteriaCountInfo: HTMLElement;
    private errorMessageNode: HTMLElement;
    private displayError: HTMLElement;
    private displaySuccess: HTMLElement;

   
    // Pattern Parameters
    private criteria: Partial<PasswordCriteria> = null;
    private _isPatternValid: boolean = false;

    //private neededCriteriaCount: number | "all" = "all";

    private regeExSpecialCharacters: RegExp = /[!"§=*$%&/_\-()#{}?}{\[\]€@]+/;

   

    setupRequirements(criteria: Partial<PasswordCriteria>) {

        this.criteria = lang.clone(criteria);
        if (criteria.regexSpecial) this.regeExSpecialCharacters = criteria.regexSpecial;
        this._showValidationRequirements();
        this.validatePassword(this._oldValue, this._newValue, this._newValueConfirmed);

    }

    private _oldValue: string;
    private _newValue: string;
    private _newValueConfirmed: string;

    private _bValuesMatch: boolean = false;

    validatePassword(oldValue: string, newValue: string, newValueConfirmed?: string): boolean {

        if (oldValue != undefined) this._oldValue = oldValue;
        if (newValue != undefined) this._newValue = newValue;
        if (newValueConfirmed != undefined) this._newValueConfirmed = newValueConfirmed;

        oldValue = this._oldValue;
        newValue = this._newValue;
        newValueConfirmed = this._newValueConfirmed;

        // beide Eingaben sind identisch?
        if (newValueConfirmed != undefined) {
            if (newValue && newValue === newValueConfirmed) {
                this._bValuesMatch = true;
            } else {
                this._bValuesMatch = false;
            }
        } else this._bValuesMatch = true;

        //this.UiModder.domClass.remove(this.passwordChange_display_confirm, "invalid");
        //this.UiModder.domClass.add(this.passwordChange_display_confirm, "valid");

        if (this._bValuesMatch != true) {
        //    this.UiModder.domClass.remove(this.passwordChange_display_confirm, "valid");
        //    this.UiModder.domClass.add(this.passwordChange_display_confirm, "invalid");
        }

        // neuer Wert ist alter Wert?
        if (oldValue && newValue && oldValue === newValue) {
            this._isPatternValid = false;
            this.displayMessage(TranslationHelpers.tryTranslate("ChangeUserPassword_errorText_newPwdSameAsOld"), true, true);
        } else {
            this._isPatternValid = this.validatePattern(newValue);
        }


        if (this._isPatternValid === true && this._bValuesMatch === true) {

            this.displayMessage(null, false, null);
            return true;
        }  else {
            return false;
        }
    }

    private validatePattern(value: string): boolean {
        let result = true;
        let criteriaCheckCount = 0;
        let criteriaNeeded = 0;

        if (this.criteria.lowercaseLetter == true) {

            if (/[a-z]+/.test(value) === false) {
                result = false;
                this.UiModder.domClass.remove(this.passwordChange_display_letter, "valid");
                this.UiModder.domClass.add(this.passwordChange_display_letter, "invalid");
            } else {
                criteriaCheckCount++;
                this.UiModder.domClass.add(this.passwordChange_display_letter, "valid");
                this.UiModder.domClass.remove(this.passwordChange_display_letter, "invalid");
            }
        }

        if (this.criteria.uppercaseLetter == true) {
            if (/[A-Z]+/.test(value) === false) {
                result = false;
                this.UiModder.domClass.add(this.passwordChange_display_capital, "invalid");
                this.UiModder.domClass.remove(this.passwordChange_display_capital, "valid");
            } else {
                criteriaCheckCount++;
                this.UiModder.domClass.add(this.passwordChange_display_capital, "valid");
                this.UiModder.domClass.remove(this.passwordChange_display_capital, "invalid");
            }
        }

        if (this.criteria.isNumberRequired == true) {
            if (/[\d]+/.test(value) === false) {
                result = false;
                this.UiModder.domClass.add(this.passwordChange_display_number, "invalid");
                this.UiModder.domClass.remove(this.passwordChange_display_number, "valid");
            } else {
                criteriaCheckCount++;
                this.UiModder.domClass.add(this.passwordChange_display_number, "valid");
                this.UiModder.domClass.remove(this.passwordChange_display_number, "invalid");
            }
        }

        if (this.criteria.specialCharacters == true) {
            if (this.regeExSpecialCharacters.test(value) === false) {
                result = false;
                this.UiModder.domClass.add(this.passwordChange_display_specialCharacters, "invalid");
                this.UiModder.domClass.remove(this.passwordChange_display_specialCharacters, "valid");
            } else {
                criteriaCheckCount++;
                this.UiModder.domClass.add(this.passwordChange_display_specialCharacters, "valid");
                this.UiModder.domClass.remove(this.passwordChange_display_specialCharacters, "invalid");
            }
        }

        if (this.criteria.passwordLength > 1) {
            if (value && value.length) {
                if (value.length < this.criteria.passwordLength) {
                    result = false;
                    this.UiModder.domClass.add(this.passwordChange_display_length, "invalid");
                    this.UiModder.domClass.remove(this.passwordChange_display_length, "valid");
                } else {
                    criteriaCheckCount++;
                    this.UiModder.domClass.add(this.passwordChange_display_length, "valid");
                    this.UiModder.domClass.remove(this.passwordChange_display_length, "invalid");
                }

            } else {
                result = false;
            }
        }

        // falls nicht alle Kriterien erfüllt sind, kann das PW trotzdem passen, wenn mindestens X erfüllt sind:
        this.UiModder.domClass.remove(this.domNode, "minCriteriaChecked");

        if (this.criteria.neededCriteriaCount != "all" && this.criteria.neededCriteriaCount > 0) {
            if (criteriaCheckCount >= this.criteria.neededCriteriaCount) {
                result = true;
                this.UiModder.domClass.add(this.domNode, "minCriteriaChecked");
            }
            this.UiModder.domClass.toggle(this.txtCriteriaCountInfo, "valid", result);
            this.UiModder.domClass.toggle(this.txtCriteriaCountInfo, "invalid", !result);

            this.UiModder.domAttr.set(this.txtCriteriaCountInfo, "innerHTML",
                this.stringFormat(this.translate("ChangeUserPassword__CriteriaCounterFormatstring"), criteriaCheckCount.toString(), this.criteria.neededCriteriaCount.toString()));
        }

        this._isPatternValid = result;


        return result;
    }

    private displayMessage(message: string, show: boolean, isException: boolean): void {

        if (show == true) {
            this.UiModder.domClass.remove(this.errorMessageNode, "w3-hide");
            if (isException == true) {
                this.UiModder.domClass.remove(this.displayError, "w3-hide");
                this.UiModder.domClass.add(this.displaySuccess, "w3-hide");

                this.displayError.innerHTML = message;


            } else {
                this.UiModder.domClass.add(this.displayError, "w3-hide");
                this.UiModder.domClass.remove(this.displaySuccess, "w3-hide");

                this.displaySuccess.innerHTML = message;
            }

            this.errorMessageNode.scrollIntoView({
                behavior: "smooth",
                block: "end",
            });

        } else {
            this.UiModder.domClass.add(this.errorMessageNode, "w3-hide");
        }


    }

    private _showValidationRequirements(): void {

        for (let parameterName in this.criteria) {
            let node: HTMLElement;

            switch (parameterName) {
                case PasswordChangeRequirements.lowercaseLetter:
                    node = this.passwordChange_display_letter;
                    break;
                case PasswordChangeRequirements.uppercaseLetter:
                    node = this.passwordChange_display_capital;
                    break;
                case PasswordChangeRequirements.isNumberRequired:
                    node = this.passwordChange_display_number;
                    break;
                case PasswordChangeRequirements.specialCharacters:
                    node = this.passwordChange_display_specialCharacters;
                    break;
                case PasswordChangeRequirements.passwordLength:
                    node = this.passwordChange_display_length;
                    this.minimumPasswordLengthDisplay.innerHTML = String(this.criteria.passwordLength);
                    break;

                case PasswordChangeRequirements.neededCriteriaCount:
                    this.hideNode(this.txtCriteriaCountInfo, this.criteria.neededCriteriaCount == "all" || !(this.criteria.neededCriteriaCount > 0));
                    node = null;
                    break;

                default: continue;
                    break;
            }
            if (node) {
                let bHide = this.criteria[parameterName] != true;
                if (parameterName == PasswordChangeRequirements.passwordLength) bHide = this.criteria.passwordLength <= 0 || !this.criteria.passwordLength;


                this.hideNode(node, bHide);
            }

        }

    }


    setMessage(message?: string) {
        this.hideNode(this.messageContainer, !message);
        this.UiModder.domAttr.set(this.messageContainer, "innerHTML", message);
    }

    // Getters && Setters ---------------------------------------END

    // Lifecycle ----------------------------------------------------------

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PasswordCriteriaCheck);
